import { nanoid } from 'nanoid'
import React from 'react'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { type ISendSMSContentProps, SendSMSContent } from './SendSMSContent/SendSMSContent.tsx'

export const sendSMS = (props: Omit<ISendSMSContentProps, 'onClose'>) => {
  const id = nanoid()
  modalStore.addModal({
    id,
    title: 'Send SMS',
    pureContent: true,
    ModalContent: () => <SendSMSContent onClose={() => modalStore.closeModal(id)} {...props} />,
  })
}
